export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
              <i className="ri-shield-check-line text-lg"></i>
            </div>
            <span className="text-xs uppercase tracking-widest text-foreground-500 font-label">Safety &amp; Trust</span>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Is Mulebuy Spreadsheet Safe?
          </h2>

          <div className="mt-8 space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              This website <strong>(mulebuyspreadsheets.hair)</strong> is an <strong>informational resource only</strong>. We provide educational content about the Mulebuy spreadsheet shopping method, category guides, and product comparisons to help shoppers make informed decisions. We do not process transactions, collect payment information, or store any personal shopping data on this site.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
              {[
                "This site is informational — no transactions are processed here",
                "All external links redirect to the main platform at kaspreadsheet.com",
                "Spreadsheet listings may be managed by third-party systems",
                "Always verify product authenticity before making a purchase",
                "Check seller ratings and reviews on the main platform",
                "Use secure payment methods when completing purchases",
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3 bg-background-100 rounded-lg p-4">
                  <i className="ri-checkbox-circle-line text-accent-600 mt-0.5 shrink-0"></i>
                  <span className="text-sm text-foreground-700">{item}</span>
                </div>
              ))}
            </div>

            <p className="mt-4">
              When you click any category link or product link on this site, you will be directed to <strong>kaspreadsheet.com</strong> — the main platform where actual browsing, selection, and purchasing takes place. The <strong>Mulebuy spreadsheet</strong> serves as your organized entry point, not a transaction processor.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}